import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Skeleton,
  Text,
} from "@chakra-ui/react";
import { formatPrice, } from "../../../../utils/formatPrice.ts";
import { formatDate, } from "../../../../utils/formatDate.ts";

export interface IUpcomingPaymentCardProps {
  /**
   * Show skeleton if true
   */
  isLoading?: boolean;
  /**
   * Payment date
   */
  date?: string;
  /**
   * Payment amount
   */
  amount?: number;
  /**
   * Callback for pay button click
   */
  onPayClick?: () => void;
}

/**
 * Card that shows nearest payment info
 */
export function UpcomingPaymentCard({
  isLoading,
  amount = 0,
  date,
  onPayClick,
}: IUpcomingPaymentCardProps,) {
  return (
    <Card
      width="100%"
      borderRadius="xl"
      variant="elevated"
      position="relative"
    >
      <CardBody px={5} py={5}>
        {isLoading && (
          <Box width="100%">
            <Skeleton height="34px" mb={4} />

            <Flex justifyContent="space-between" gap="10">
              <Skeleton height="34px" flex="0.4" />
              <Skeleton height="34px" flex="0.5" />
            </Flex>
          </Box>
        )}

        {!isLoading && (
          <Flex flexDir="column" gap={4}>
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize="xl" fontWeight="bold" flex="0.7">
                Ближайший платеж
              </Text>

              <Text fontSize="xl" fontWeight="bold">
                {formatPrice(amount / 100, 0,)}
              </Text>
            </Flex>
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize="sm" color="gray.500">
                до
                {" "}
                {formatDate(new Date(date!,), { year: "numeric", },)}
              </Text>

              <Button
                size="sm"
                px={6}
                colorScheme="brand"
                onClick={onPayClick}
              >
                Оплатить
              </Button>
            </Flex>
          </Flex>
        )}
      </CardBody>
    </Card>
  );
}
